import React from 'react';

import { ContentDetailSection, DetailEditButton } from '~src/app/content/contentDetailDialog/ContentDetailSection';
import { Messages } from '~src/codegen/Localize';
import { ContentActionsService } from '~src/commonInfra/contentActions/ContentActions';
import { RemoteQueryAgentHelper } from '~src/ts/helpers/RemoteQueryAgentHelper';
import { IDataSourceDetailInfo } from '~src/ts/models/IDataSourceInfo';


/** THIS SECTION IS USED FOR DEBUGGING ONLY. NOT CUSTOMER FACING **/
interface RemoteQueryAgentDetailSectionOwnProps {
  readonly datasource: IDataSourceDetailInfo;
}

export function RemoteQueryAgentDetailSection(props: RemoteQueryAgentDetailSectionOwnProps): JSX.Element {

  const changeRemoteQueryAgent = () => {
    return ContentActionsService.changeRemoteQueryAgentOnDatasource(props.datasource);
  };

  return (
    <ContentDetailSection
      header={Messages.datasourceRemoteQueryAgent()}
      testId={'remote-query-agent'}
      detail={RemoteQueryAgentHelper.getRemoteQueryAgentDisplayName(props.datasource)}
      isActionAllowed={true}
      action={<DetailEditButton
        buttonLabel={Messages.editDatasourceRemoteQueryAgent_action()}
        buttonTestId={'change-remote-query-agent'}
        onClickAction={changeRemoteQueryAgent}
      />}
    />);
}
